@if (!showSwiper()){
    <div class="swiper-details__skeleton" [ngClass]="{'modalSize': isModal()}">
        @for (multimedia of items(); track multimedia) {
            <div class="swiper-details__skeleton__item"></div>
        }
    </div>
}

<section 
    #swiper
    [class]="'swiper swiper-details ' + 'swiper-details--' + multimedia().length"
    [class.dnone]="!showSwiper()" 
    [class.dblock]="showSwiper()"
>
  <ul class="swiper-wrapper">
    @for(media of multimedia(); track $index) {
      <li 
        [class]="'swiper-slide ' + 'swiper-slide--' + multimedia().length"
      >
        @if(media.type === 'video') {
            <video [src]="media.name" [ngClass]="{'modalSize': isModal()}" controls></video>
        }
        @if(media.type === 'image') {
            <img draggable="false" [src]="media.name" (error)="tools.onImageError($event)" (click)="openModal(media.imageIndex, galleryImages, media.imageIndex)" [ngClass]="{'modalSize': isModal()}">
        }
      </li>
    }
  </ul>
  
  <!-- Paginación -->
  <div class="swiper-pagination"></div>
    
    <!-- Botones de navegación -->
  <div 
    class="swiper-button__wrapper" 
    [style]="'--multimedia-count: ' + multimedia().length"
  >
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>

</section>